import type { AnalyticsGroupEvent, AnalyticsIdentifyEvent } from './server-types';
import type { Analytics, AnalyticsUser, PageEvent, TrackEvent } from './types';

class ConsoleAnalytics implements Analytics {
  name = 'console';

  async initialize(): Promise<void> {
    return;
  }

  track(e: Partial<TrackEvent>): void {
    console.debug('analytics.track', e);
  }
  page(e: Partial<PageEvent>): void {
    console.debug('analytics.page', e);
  }
  identify(e: Partial<AnalyticsIdentifyEvent>): void {
    console.debug('analytics.identify', e);
  }
  group(e: Partial<AnalyticsGroupEvent>): void {
    console.debug('analytics.group', e);
  }
  user(): AnalyticsUser | undefined {
    return;
  }
  reset(): void {
    return;
  }
}

export const consoleAnalytics = new ConsoleAnalytics();
